export default {"src":"/_next/static/media/0xff970a61a04b1ca14834a43f5de4533ebddb5cc8.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};